export default __webpack_public_path__ + "static/media/facebook.fc7efc6d.svg";